var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAllergenFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    stroke: "#EF9500",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4459 11.6988C9.357 12.3005 7.5874 13.8608 7.5874 13.8608C8.41348 17.2144 11.0769 20.2772 13.6055 20.2824C13.7827 20.7714 14.2282 21.0784 14.6591 20.9825C15.0886 20.8886 15.3483 20.4275 15.2932 19.9171C16.0321 19.5751 16.6662 19.0091 17.1561 18.2545C17.3453 17.9631 17.5131 17.6444 17.6554 17.2979C18.2654 15.8323 18.2117 13.3608 17.8043 11.5913C17.8037 11.5907 15.62 11.0803 12.4459 11.6988Z",
    fill: "#EF9500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20898 13.4061C8.64505 12.4067 10.3831 11.638 12.3245 11.2163C14.2592 10.796 16.1636 10.7714 17.8997 11.0771L17.9514 10.9741C18.2647 10.3407 18.3553 9.68523 18.2111 9.07966C17.7453 7.125 15.0933 6.0706 12.0091 6.51749C11.9272 5.64313 11.5407 4.8044 10.8898 4.17552C10.6475 3.94171 10.2563 3.94171 10.0147 4.17422C9.7711 4.40738 9.77311 4.78433 10.0134 5.01878C10.4965 5.4851 10.7723 6.11917 10.7931 6.77396C8.90542 7.28303 7.33312 8.27915 6.5406 9.50065C6.05542 10.2481 5.89235 11.0343 6.06951 11.7759C6.21379 12.3808 6.59227 12.9326 7.16066 13.3705L7.20898 13.4061Z",
    fill: "#EF9500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAllergenFree);
export default __webpack_public_path__ + "static/media/icon-allergen-free.22d61e6c2b8905bf77396483af5ef7a9.svg";
export { ForwardRef as ReactComponent };